import {Form, Formik, useFormikContext} from 'formik'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import React from 'react'
import {useHistory} from 'react-router'
import {FormikChanges} from 'util/formikchanges'
import {t, useTranslation} from 'util/i18n'
import {FormField} from 'views/form/form'
import {Step} from 'views/registration/step'
import {DetailsInfoState} from '../../../models/registration/steps/DetailsStepModel'
import {
	GiftStepModel,
	GiftStepState
} from '../../../models/registration/steps/GiftStepModel'
import {Trusted} from '../../../util/trusted'

export const GiftStep: React.FC<{
	registration: RegistrationModel
	updateRegistration: (model: RegistrationModel) => void
}> = attrs => {
	const {registration, updateRegistration} = attrs
	const step = registration.allSteps.gift
	const history = useHistory()

	return (
		<Formik<GiftStepState>
			initialValues={{...step.state}}
			onSubmit={() => {
				history.push(`#${step.nextStepKey}`)
			}}
		>
			<Form>
				<FormikChanges
					onChange={({values}) => {
						const newRegistration = step.setState(values)
						updateRegistration(newRegistration)
					}}
				/>
				<Step step={step} hasFormSubmit={true}>
					<GiftStepField step={step} />
				</Step>
			</Form>
		</Formik>
	)
}

export const GiftStepField: React.FC<{
	step: GiftStepModel
}> = ({step}) => {
	const {values} = useFormikContext<GiftStepState>()
	const t = useTranslation('gift')

	return (
		<>
			<FormField
				type="radio"
				name="consent"
				value="accept"
				label={<Trusted>{step.config.consent_accept}</Trusted>}
				required
			/>
			<FormField
				type="radio"
				name="consent"
				value="decline"
				label={<Trusted>{step.config.consent_decline}</Trusted>}
				required
			/>
			{values.consent === 'accept' && (
				<>
					<FormField name="lastname" label={t('lastname')} required />
					<FormField name="firstname" label={t('firstname')} required />
					<FormField name="postalcode" label={t('postalcode')} required />
					<FormField name="prefecture" label={t('prefecture')} required />
					<FormField name="city" label={t('city')} required />
					<FormField name="address" label={t('address')} required />
					<FormField name="company" label={t('company')} />
					<FormField name="building" label={t('building')} />
					<FormField name="phone" label={t('phone')} required />
				</>
			)}
		</>
	)
}

export const GiftField: React.FC<{
	name: keyof DetailsInfoState
	help?: string
	type?: 'email'
} & Record<string, any>> = ({help, step, name, ...props}) => {
	return (
		<FormField
			name={name}
			label={t(`details.${name}`)}
			help={help}
			{...props}
		/>
	)
}
